'use client'

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '@/hooks/useUser'
import EarningsDashboard from '@/components/landlord/EarningsDashboard'
import Layout from '@/components/Layout'

export default function LandlordEarningsPage() {
  const navigate = useNavigate()
  const { user, loading } = useUser()

  useEffect(() => {
    if (!loading && (!user || user.role !== 'landlord')) {
      navigate('/auth', { replace: true })
    }
  }, [loading, user, navigate])

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
        </div>
      </Layout>
    )
  }

  if (!user || user.role !== 'landlord') {
    return null
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <EarningsDashboard />
      </div>
    </Layout>
  )
}

